import { transformIdentifyEvent } from '@fff-web/schema-validations';
import { FilteredIdentifyProps, GetUserInfoProps, TraitsProps } from '../../interfaces';
import { formatMemberStatus, formatPlanCode, formatRole } from './formatFields';

const identifyInfo = ({
  userInfo,
  traits,
}: {
  userInfo?: GetUserInfoProps;
  traits?: TraitsProps;
}): FilteredIdentifyProps => {
  const result = transformIdentifyEvent(
    { userInfo, traits },
    {
      formatRole,
      formatMemberStatus,
      formatPlanCode,
    },
  );

  if (!result.success) {
    console.warn('identifyInfo transformation failed:', result.error, 'Field:', result.field);
    return {};
  }

  return result.data;
};

export default identifyInfo;
